var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-7"},[_c('h1',{staticClass:"text-center display-3"},[_vm._v("Terms And Conditions")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.tac)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }